export const PENDING = "Pending";
export const CONFIRMED = "Confirmed";
export const COMPLETED = "Completed";
export const EXPIRED = "Expired";